import healoLogoLight from '@/assets/healo-logo.png';
import healoLogoDark from '@/assets/healo-logo-dark.png';

// Brand mark that follows the app theme: light tile in light, navy tile in dark. Theme is driven
// by the `.dark` class on <html>, so we render both and toggle with CSS rather than
// threading a `theme` prop through every call site.
function HealoLogo({ className = '', width, height }) {
  return (
    <>
      <img
        src={healoLogoLight}
        alt=""
        aria-hidden
        width={width}
        height={height}
        className={`${className} dark:hidden`.trim()}
      />
      <img
        src={healoLogoDark}
        alt=""
        aria-hidden
        width={width}
        height={height}
        className={`${className} hidden dark:block`.trim()}
      />
    </>
  );
}

export default HealoLogo;
